export default __webpack_public_path__ + "static/media/plus.eb7c2a88.svg";